import { render, staticRenderFns } from "./EduBatchDeleteButton.vue?vue&type=template&id=cd59fb4c&scoped=true"
import script from "./EduBatchDeleteButton.vue?vue&type=script&lang=js"
export * from "./EduBatchDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd59fb4c",
  null
  
)

export default component.exports